import { Spin, TablePaginationConfig } from "antd";
import { activityPayout, activitySold, activityTransferComplete, activityTransferRequest, ListingActivity } from "../api/models";
import moment from "moment";
import { formatCurrency } from "../utils";
import { DomainName } from "./ui";

export interface Props {
    pagination: TablePaginationConfig;
    data: ListingActivity[] | undefined;
    onPaginationChange: (pagination: TablePaginationConfig) => void;
}

const ListingActivityTable = (props: Props) => {
    function getDetails(a: ListingActivity) {
        if (a.type == 'cancelled') {
            return <span>Sale was cancelled.</span>;
        } else if (a.type == 'sold') {
            const sold = activitySold.parse(JSON.parse(a.data));
            return <span>Sold for {formatCurrency(sold.price)}. Transfer Type: {sold.type}. Payout Type: {sold.payoutType}</span>;
        } else if (a.type == 'transferComplete') {
            const transfer = activityTransferComplete.parse(JSON.parse(a.data));
            return <span>Transfer Complete</span>;
        } else if (a.type == 'transferRequest') {
            const transfer = activityTransferRequest.parse(JSON.parse(a.data));
            return <span>Transfer Request</span>;
        } else if (a.type == 'payout') {
            const payout = activityPayout.parse(JSON.parse(a.data));
            if (payout.type == 'installment') {
                return <span>Installment (LTO) Payout, {formatCurrency(payout.amount)} so far, installment {payout.installment} of {payout.totalInstallments}.</span>;
            } else {
                return <span>Payout, total: {formatCurrency(payout.amount)}</span>;
            }
        } else {
            return '';
        }
    }

    if (!props.data) {
        return <div className="flex justify-center py-6"><Spin /></div>;
    }

    const totalPages = props.pagination.total && props.pagination.pageSize
        ? Math.ceil(props.pagination.total / props.pagination.pageSize)
        : 1;

    return (
        <div>
            <table className="w-full">
                <thead>
                    <tr>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Domain</th>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Type</th>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Venue/Account</th>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Created At</th>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Details</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.map((a) => (
                        <tr key={a.domain + '-' + a.createdAt} className="border-t border-border hover:bg-bg-elevated transition-colors">
                            <td className="py-2 px-3 text-sm text-text"><DomainName name={a.domain} /></td>
                            <td className="py-2 px-3 text-sm text-text-2">{a.type}</td>
                            <td className="py-2 px-3 text-sm text-text-2">{a.source} ({a.account})</td>
                            <td className="py-2 px-3 text-sm text-text-2 font-mono tabular-nums whitespace-nowrap">{moment(a.createdAt).format('LLL')}</td>
                            <td className="py-2 px-3 text-sm text-text-2">{getDetails(a)}</td>
                        </tr>
                    ))}
                    {props.data.length === 0 && (
                        <tr><td colSpan={5} className="py-4 text-center text-sm text-text-3">No activity found</td></tr>
                    )}
                </tbody>
            </table>
            {props.pagination.total != null && props.pagination.total > 0 && (
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-border">
                    <span className="text-xs text-text-3">Total {props.pagination.total} records</span>
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            disabled={(props.pagination.current || 1) <= 1}
                            onClick={() => props.onPaginationChange({ ...props.pagination, current: (props.pagination.current || 1) - 1 })}
                            className="text-xs text-accent hover:opacity-80 disabled:text-text-3 disabled:cursor-default cursor-pointer"
                        >
                            Prev
                        </button>
                        <span className="text-xs text-text-2 font-mono tabular-nums">{props.pagination.current || 1} / {totalPages}</span>
                        <button
                            type="button"
                            disabled={(props.pagination.current || 1) >= totalPages}
                            onClick={() => props.onPaginationChange({ ...props.pagination, current: (props.pagination.current || 1) + 1 })}
                            className="text-xs text-accent hover:opacity-80 disabled:text-text-3 disabled:cursor-default cursor-pointer"
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
export default ListingActivityTable;
